import { createActions, createReducer } from 'reduxsauce'

import ConsultaEmpenhoCredorService from '../../servicos/ConsultaEmpenhoCredorService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaConsultaEmpenhoCredorInicio: [],
    buscaConsultaEmpenhoCredorSucesso: ['consultaEmpenhoCredor'],
    buscaConsultaEmpenhoCredorErro: ['erro'],
    setSelecionadoConsultaEmpenhoCredorSucesso: ['selecionado'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
    selecionado: null,
    dataSincronizacaoDados: null,
}

// Ação para busca completa
Creators.buscaConsultaEmpenhoCredor = filtro => {
    return dispatch => {
        dispatch(Creators.buscaConsultaEmpenhoCredorInicio())
        let serv = new ConsultaEmpenhoCredorService()
        return serv
            .consultar(filtro)
            .then(response => dispatch(Creators.buscaConsultaEmpenhoCredorSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaConsultaEmpenhoCredorErro(error)))
    }
}

const buscaConsultaEmpenhoCredorInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaConsultaEmpenhoCredorErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaConsultaEmpenhoCredorSucesso = (state = INITIAL_STATE, action) => {
    return {
        ...state,
        lista: action.consultaEmpenhoCredor.resultado,
        dataSincronizacaoDados: action.consultaEmpenhoCredor.dataSincronizacaoDados,
        carregando: false,
        fonte: action.consultaEmpenhoCredor.fonte,
    }
}

const setSelecionadoConsultaEmpenhoCredorSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, selecionado: action.selecionado, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_INICIO]: buscaConsultaEmpenhoCredorInicio,
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_ERRO]: buscaConsultaEmpenhoCredorErro,
    [Types.BUSCA_CONSULTA_EMPENHO_CREDOR_SUCESSO]: buscaConsultaEmpenhoCredorSucesso,
    [Types.SET_SELECIONADO_CONSULTA_EMPENHO_CREDOR_SUCESSO]: setSelecionadoConsultaEmpenhoCredorSucesso,
})
